import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { useSessionStore } from '@Stores';
import { ROLES } from '@AuthModule';

/** Block direct URL access to equipment-rental views when the shelter flag is off OR the user
 *  doesn't hold the Equipment Rental permission (the navbar already hides the entries; this guards
 *  typed URLs / shared links). Falls through to the dashboard. */
function requireEquipmentRentalAccess(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const sessionStore = useSessionStore();
  if (sessionStore.shelterProfile?.equipment_rental_enabled && sessionStore.can(ROLES.EQUIPMENT_RENTAL)) {
    return next();
  }

  return next({ path: '/shelter' });
}

export default <RouteRecordRaw[]>[
  {
    path: 'equipment-rental',
    redirect: '/shelter/equipment-rental/inventory',
    beforeEnter: requireEquipmentRentalAccess,
  },
  {
    path: 'equipment-rental/inventory',
    name: 'equipment-rental-inventory',
    component: () => import('./views/EquipmentRentalInventory.view.vue'),
    beforeEnter: requireEquipmentRentalAccess,
  },
  {
    path: 'equipment-rental/archive',
    name: 'equipment-rental-archive',
    component: () => import('./views/EquipmentRentalArchive.view.vue'),
    beforeEnter: requireEquipmentRentalAccess,
  },
  {
    path: 'equipment-rental/report',
    name: 'equipment-rental-report',
    component: () => import('../Report/views/ReportsEquipmentRental.view.vue'),
    beforeEnter: requireEquipmentRentalAccess,
  },
];
